<template>
  <div class="clientes">
    <h1 class="titulo-card fs-4">Helpdesk / Ticket</h1>
    <div v-if="(ticket)" class="form-group card-principal">
      <div class="row">
        <div class="col-auto">
          <button v-on:click="$router.go(-1)" class="btn btn-outline-primary">
            <font-awesome-icon :icon="['fas', 'arrow-left']" fixed-width class="me-1"/>Voltar
          </button>
        </div>
        <div class="col">
        </div>
        <div class="col-auto">
          <div class="input-group mb-3">
            <button v-on:click="$router.go(-1)" disabled class="btn btn-outline-secondary">
              <font-awesome-icon :icon="['fas', 'print']" fixed-width class="me-1"/>
            </button>
            <button v-if="ticketAberto()" v-on:click="editarTicketHandle()" class="btn btn-primary">
              <font-awesome-icon :icon="['fas', 'edit']" fixed-width class="me-1"/>Editar
            </button>
            <button v-if="(!podeEncerrarTicket() && ticket.estagio !== 'etEncerrado')" class="btn btn-secondary" disabled>
              <font-awesome-icon :icon="['fas', 'check-double']" fixed-width class="me-1"/>Encerrar
            </button>
            <button v-if="podeEncerrarTicket()" v-on:click="encerrarTicketHandle()" class="btn btn-success">
              <font-awesome-icon :icon="['fas', 'check-double']" fixed-width class="me-1"/>Encerrar
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h4>
            <strong>TICKET</strong> #{{ticket.id}}
            <span v-if="!ticketAberto()" class="text-danger">(encerrado)</span>
          </h4>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-12 col-md">
          <div class="card p-2 mb-2">
            <p class="fw-bold mb-0">
              <font-awesome-icon :icon="['far', 'address-card']" fixed-width class="me-1"/>
              Dados do ticket
            </p>
            <div class="row">
              <div class="col-12 col-sm-auto" style="min-width: 100px;">
                <p class="mb-0"><strong>Solicitante:</strong></p>
              </div>
              <div class="col ms-3 ms-sm-0">
                {{ticket.identificacao}}
              </div>
              <div class="w-100"></div>

              <div class="col-12 col-sm-auto" style="min-width: 100px;">
                <p class="mb-0"><strong>Contato:</strong></p>
              </div>
              <div class="col ms-3 ms-sm-0">
                {{ticket.contato}}
              </div>
              <div class="w-100"></div>

              <div class="col-12 col-sm-auto" style="min-width: 100px;">
                <p class="mb-0"><strong>Título:</strong></p>
              </div>
              <div class="col ms-3 ms-sm-0">
                {{ticket.descricao_curta || '-'}}
              </div>
              <div class="w-100"></div>

              <div class="col-12 col-sm-auto" style="min-width: 100px;">
                <p class="mb-0"><strong>Previsão:</strong></p>
              </div>
              <div class="col ms-3 ms-sm-0">
                {{ticket.previsao || '-'}}
                <font-awesome-icon v-if="ticket.estagio === 'etAberto'" v-on:click="novaPrevisaoHandle()" :icon="['far', 'calendar']" fixed-width class="ms-1 cursor-pointer text-primary"/>
                <span v-if="ticket._atrasado === true" class="badge rounded-pill bg-danger ms-1">
                  Atrasado
                </span>

                <div v-if="!!novaPrevisao" class="form-group mt-1">
                  <div class="input-group mb-3">
                    <datetime type="datetime" v-model="novaPrevisao" :minute-step="15" use12-hour input-class="form-control"></datetime>
                    <button v-on:click="novaPrevisao = undefined" class="btn btn-danger" type="button">
                      <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                    </button>
                    <button v-on:click="salvaNovaPrevisaoHandle()" class="btn btn-success" type="button">
                      <font-awesome-icon :icon="['far', 'save']" fixed-width/>
                    </button>
                  </div>
                </div>
              </div>
              <div class="w-100"></div>

              <div class="col-12 col-sm-auto" style="min-width: 100px;">
                <p class="mb-0"><strong>Descrição:</strong></p>
              </div>
              <div class="col ms-3 ms-sm-0">
                {{ticket.descricao_longa || '-'}}
              </div>
              <div class="w-100"></div>
            </div>
          </div>
        </div>

        <div v-if="atividadePossuiAnexo(0)" class="col-12 col-md-4">
          <div class="card d-grid gap-2 p-2">
            <p class="fw-bold mb-0">
              <font-awesome-icon :icon="['fas', 'paperclip']" fixed-width class="me-1"/>
              Anexos
            </p>
            <div v-for="anexo in anexosAtividade(0)" :key="anexo.id" class="row g-1">
              <div class="col d-grid gap-2">
                <button v-on:click="baixaAnexo(anexo)" class="btn btn-sm btn-block btn-outline-secondary">
                  <font-awesome-icon :icon="['fas', 'download']" fixed-width class="me-1"/>{{apenasNomeArquivo(anexo.caminho)}}
                </button>
              </div>
              <div class="col-auto">
                <button v-on:click="removeAnexoHandle(anexo)" class="btn btn-sm btn-outline-danger">
                  <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="(ticket.estagio == 'etCriacao')" class="alert alert-warning">
        Ticket está em estágio de criação. Aguarde o atendente liberar para atendimento.
      </div>

      <div v-if="(ticket.estagio == 'etAberto' && !ticket.atendimento_iniciado)" class="form-group m-0 p-0 d-grid gap-2">
        <button v-if="formAnotacao.tipo" v-on:click="iniciarAtendimentoHandler()" class="btn btn-block btn-success">
          <font-awesome-icon :icon="['fas', 'play']" fixed-width class="me-1"/>
          Iniciar atendimento
        </button>
      </div>
      <div v-if="(ticket.atendimento_iniciado)" class="form-group m-0 p-0">
        <div v-if="(!formAnotacao.visivel)" class="form-group">
          <button v-if="ticketAberto()" v-on:click="abreNovaAnotacao()" class="btn btn-success">
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Nova anotação
          </button>
        </div>

        <div v-if="(formAnotacao.visivel)" class="row mb-3">
          <div class="col-12 mb-3">
            <div class="form-group" v-bind:class="classeFormAnotacao()">
              <h5 class="w-100 fw-bold-">
                Adicionar anotação
                <button type="button" v-on:click="fechaNovaAnotacao()" class="btn btn-danger btn-sm float-end">
                  <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                </button>
              </h5>
              <textarea v-model="formAnotacao.mensagem" rows="4" class="form-control" maxlength="256"></textarea>
            </div>
          </div>
          <div v-if="(formAnotacao.anexos.length)" class="col-12 mb-2">
            <p class="fw-bold mb-0">Anexos:</p>
            <div v-for="anexo in formAnotacao.anexos" :key="anexo.id" class="form-group border pe-1 pt-1 pb-2">
              <label>File
                <input type="file" @change="handleFileUpload(anexo, $event)"/>
              </label>
              <button v-on:click="removeAnexoHandle(anexo)" class="btn btn-sm btn-outline-danger float-end" type="button">
                <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
              </button>
            </div>
          </div>
          <div class="col-12 col-md mb-2">
            <div class="form-group" v-bind:class="classeFormAnotacao()">
              <div class="dropdown d-grid gap-2">
                <button class="btn btn-block dropdown-toggle" type="button" id="triggerDDTipoMensagem" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{textoDDTipoAnotacao}}
                </button>
                <ul class="dropdown-menu dropdown-menu-dark w-100" aria-labelledby="triggerDDTipoMensagem">
                  <li><button class="dropdown-item text-warning" type="button" v-on:click="formAnotacao.tipo = 'atMensagemPrivada'">{{traduzTipoMensagem('atMensagemPrivada')}}</button></li>
                  <li><button class="dropdown-item text-success" type="button" v-on:click="formAnotacao.tipo = 'atMensagemPublica'">{{traduzTipoMensagem('atMensagemPublica')}}</button></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-auto">
            <div class="d-grid gap-2">
              <button v-if="formAnotacao.tipo" v-on:click="novoAnexoHandle()" class="btn btn-block btn-outline-primary">
                <font-awesome-icon :icon="['fas', 'upload']" fixed-width class="me-1"/>
                Anexar arquivos
              </button>
            </div>
          </div>
          <div class="col-12 col-md-auto">
            <div class="d-grid gap-2">
              <button v-if="'atMensagemPrivada' === formAnotacao.tipo" v-on:click="adicionarAnotacaoHandle()" class="btn btn-block btn-warning">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>
                Adicionar
              </button>
              <button v-if="'atMensagemPublica' === formAnotacao.tipo" v-on:click="adicionarAnotacaoHandle()" class="btn btn-block btn-success">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>
                Adicionar
              </button>
            </div>
          </div>
        </div>

        <div v-if="(carregandoAtividades)" class="form-group">
            <font-awesome-icon :icon="['fas', 'spinner']" fixed-width class="me-1"/>
        </div>

        <p v-if="(carregandoAtividades)" class="mb-0 pt-2 fw-bold">Atividades:</p>
        <div v-for="atividade in atividades" :key="atividade.id" class="row no-gutters mb-0 p-2" role="alert">
          <p class="mb-0 small text-muted">
            {{atividade.timestamp}} - por fulano de tal
            <span v-if="atividade.acao === 'atMensagemPublica'" class="text-warning">- Mensagem pública</span>
          </p>
          <div v-if="(!atividadeValida(atividade))" class="form-group">
            Atividade inválida '{{atividade.acao}}'
          </div>

          <div v-if="atividade.acao === 'atMensagemPrivada'" class="col-12">
            <div class="alert alert-secondary pb-0 pt-0 mb-0 small" role="alert" style="white-space: pre;">
              {{atividade.descricao}}

              <!-- refatorar -->
              <div v-if="atividadePossuiAnexo(atividade.id)" class="form-group mb-1">
                <div v-for="anexo in anexosAtividade(atividade.id)" :key="anexo.id" class="btn-group me-2" role="group" aria-label="Basic example">
                  <button v-on:click="baixaAnexo(anexo)" class="btn btn-sm btn-outline-secondary">
                    <font-awesome-icon :icon="['fas', 'paperclip']" fixed-width class="me-1"/>{{apenasNomeArquivo(anexo.caminho)}}
                  </button>
                  <button v-on:click="removeAnexoHandle(anexo)" type="button" class="btn btn-sm btn-outline-danger">
                    <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                  </button>
                </div>
              </div>
              <!-- refatorar -->
            </div>
          </div>

          <div v-if="atividade.acao === 'atMensagemPublica'" class="col-12">
            <div class="alert alert-warning pb-0 pt-0 mb-0 small border-warning" role="alert" style="white-space: pre;">
              {{atividade.descricao}}

              <!-- refatorar -->
              <div v-if="atividadePossuiAnexo(atividade.id)" class="form-group mb-1">
                <div v-for="anexo in anexosAtividade(atividade.id)" :key="anexo.id" class="btn-group me-2" role="group" aria-label="Basic example">
                  <button v-on:click="baixaAnexo(anexo)" type="button" class="btn btn-sm btn-outline-secondary">
                    <font-awesome-icon :icon="['fas', 'paperclip']" fixed-width class="me-1"/>{{apenasNomeArquivo(anexo.caminho)}}
                  </button>
                  <button v-on:click="removeAnexoHandle(anexo)" type="button" class="btn btn-sm btn-outline-danger">
                    <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                  </button>
                </div>
              </div>
              <!-- refatorar -->
            </div>
          </div>

          <div v-if="atividade.acao !== 'atMensagemPublica' && atividade.acao !== 'atMensagemPrivada' && atividade.acao !== 'atMensagemPrivada'" class="col-12">
            <div v-bind:class="classeAtividade(atividade)" class="alert pb-1 pt-1 mb-0 ps-2 pe-2 small" role="alert" style="white-space: pre;">
              {{escreveAtividade(atividade)}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import store from '@/store'
import pesquisaCliente from '@/modules/pesquisa-cliente'
import { Datetime } from 'vue-datetime';

export default {
  name: 'Ticket',
  components: {
    Datetime,
  },
  data() {
    return {
      meuID: 0,
      meuGrupoID: 0,
      ticketID: undefined,
      ticket: undefined,
      clienteSelecionado: undefined,
      carregandoAtividades: true,
      listaGrupos: [],
      listaOperadores: [],
      atividades: [],
      indiceAnexo: 0,
      novaPrevisao: undefined,
      formAnotacao: {
        visivel: false,
        id: undefined,
        mensagem: '',
        tipo: '', // atMensagemPrivada, atMensagemPublica
        anexos: [],
      }
    }
  },
  methods: {
    resetFormAnotacao() {
      this.formAnotacao.id = undefined;
      this.formAnotacao.mensagem = '';
      this.formAnotacao.tipo = 'atMensagemPrivada';
    },

    carregaMeuID() {
      const userData = store.getters['auth/getUserData'];

      this.meuID = userData.funcionario_id;
      this.meuGrupoID = userData.helpdesk_grupo_id;
    },

    carregaTicket() {
      const apiUrl = `/helpdesk/tickets/${this.ticketID}`;

      loading(true);
      this.clienteSelecionado = undefined;

      api.get(apiUrl).then(async res => {
        this.ticket = res.data;

        if (this.ticket.cliente_id) {
          await pesquisaCliente(this.ticket.cliente_id).then(res => {
            this.clienteSelecionado = clone(res);
          }).catch(error => {
            dialogo.erroHttp(error);
          });
        }

        loading(false);
      }).catch(error => {
        loading(false);

        dialogo.erroHttp(error).then(() => {
          this.$router.push({ path: `/helpdesk` });
        });
      });
    },

    removeClienteSelecionado() {
      this.clienteSelecionado = undefined;
      this.ticket.cliente_id = 0;
    },

    abreModalPesquisaClientes() {
      pesquisaCliente().then(res => {
        this.clienteSelecionado = clone(res);
        this.ticket.cliente_id = res.id;
      });
    },

    carregaGrupos() {
      api.get(`/helpdesk/grupos?paginacao.porPagina=-1&orderBy[prioridade]=desc`).then(res => {
        this.listaGrupos = res.data.itens;
      }).catch(() => {
        setTimeout(() => {
          this.carregaGrupos();
        }, 1000);
      });
    },

    nomeGrupo(id) {
      if (!id) {
        return 'Nenhum';
      }

      const grupo = this.listaGrupos.find(x => x.id === id);

      if (!grupo) {
        return 'Não encontrado';
      }

      return grupo.descricao;
    },

    carregaOperadores() {
      api.get(`/usuarios?paginacao.porPagina=-1&orderBy[nome]=desc`).then(res => {
        // this.listaOperadores = res.data.itens;
        this.listaOperadores = [];

        res.data.itens.forEach(x => {
          if (x.id != this.meuID) {
            this.listaOperadores.push(x);
          }
        });

      }).catch(() => {
        setTimeout(() => {
          this.carregaOperadores();
        }, 1000);
      });
    },

    carregaAtividades() {
      //const apiUrl = `/helpdesk/tickets/${this.ticketID}/atividades?orderBy[created_at]=desc`;
      const apiUrl = `/helpdesk/tickets/${this.ticketID}/atividades`;

      this.carregandoAtividades = true;

      api.get(apiUrl).then(res => {
        this.carregandoAtividades = false;
        this.atividades = res.data;
      }).catch(() => {
        this.carregandoAtividades = false;
      });
    },

    salvaAlteracoes() {
      const sendData = clone(this.ticket);

      loading(true);

      return api.put(`/helpdesk/tickets/${sendData.id}`, sendData).then(() => {
        loading(false);
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    //TODO: tornar esta função como global
    /**
     * @param {Number} numero
     * @param {Number} zeros
     * @returns {string} Strins com "zeros" à esquerda do número informado
     **/
    strZero(numero, zeros){
        return Array(zeros-String(numero).length+1).join('0') + numero;
    },

    // TODO: tornar esta função como global
    /**
     * @param {Date} data
     * @returns {string} Data no formato YYYY-MM-DD
     **/
    dateTimeToMySQLDateTimeTzBrasilStr(data) {
      const dia = this.strZero(data.getDate(), 2);
      const mes = this.strZero(data.getMonth()+1, 2);
      const hora = this.strZero(data.getHours(), 2);
      const minuto = this.strZero(data.getMinutes(), 2);
      const segundo = this.strZero(data.getSeconds(), 2);

      return `${data.getFullYear()}-${mes}-${dia}T${hora}:${minuto}:${segundo}.000-03:00`;
    },

    // TODO: tornar esta função como global
    /**
     * @param {Date} data
     * @returns {string} Data no formato YYYY-MM-DD
     **/
    dateTimeToMySQLDateTimeStr(data) {
      const dia = this.strZero(data.getDate(), 2);
      const mes = this.strZero(data.getMonth()+1, 2);
      const hora = this.strZero(data.getHours(), 2);
      const minuto = this.strZero(data.getMinutes(), 2);
      const segundo = this.strZero(data.getSeconds(), 2);

      return `${data.getFullYear()}-${mes}-${dia} ${hora}:${minuto}:${segundo}`;
    },

    novaPrevisaoHandle() {
      const previsao = new Date(this.ticket.previsao);
      this.novaPrevisao = this.dateTimeToMySQLDateTimeTzBrasilStr(previsao);
    },

    salvaNovaPrevisaoHandle() {
      const _vm = this;
      const previsao = new Date(this.novaPrevisao);

      const sendData = {
        previsao: this.dateTimeToMySQLDateTimeStr(previsao),
      };

      loading(true);
      api.patch(`/helpdesk/tickets/${this.ticketID}`, sendData).then(res => {
        loading(false);
        _vm.ticket._atrasado = res.data._atrasado;
        _vm.ticket.previsao = res.data.previsao;
        _vm.novaPrevisao = undefined;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    novoAnexoHandle() {
      this.indiceAnexo++;

      const objAnexo = {
        id: this.indiceAnexo,
        file: undefined,
      }

      this.formAnotacao.anexos.push(objAnexo);
    },

    handleFileUpload(anexo, event){
      anexo.file = event.target.files[0];
    },

    salvarHandle() {
      this.salvaAlteracoes();
    },

    salvarESairHandle() {
      this.salvaAlteracoes().then(() => {
        this.$router.push({ path: `/helpdesk` });
      });
    },

    editarTicketHandle() {
        this.$router.push({ path: `/helpdesk/tickets/${this.ticketID}/editar` });
    },

    podeEncerrarTicket() {
      return (this.ticket.estagio == 'etAberto' && this.ticket.atendimento_iniciado == true);
    },

    encerrarTicketHandle() {
      // TODO: ao clicar aqui, exibir alerta para o cliente caso contenha texto não salvo no formulário

      dialogo.confirmacao(`Confirma encerrar este ticket?`).then(() => {
        const sendData = {
          estagio: 'etEncerrado',
        };

        api.patch(`/helpdesk/tickets/${this.ticketID}`, sendData).then(() => {
          loading(false);
          dialogo.alerta('O ticket foi encerrado com sucesso.').then(() => {
            this.$router.go(-1)
            // this.$router.push({ path: `/helpdesk` });
          });
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    iniciarAtendimentoHandler() {
      const _vm = this;
      const sendData = {
        atendimento_iniciado: true,
      };

      loading(true);
      api.patch(`/helpdesk/tickets/${this.ticketID}`, sendData).then(() => {
        loading(false);
        _vm.ticket.atendimento_iniciado = true;
      }).catch((error) => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    abreNovaAnotacao() {
      this.formAnotacao.visivel = true;
    },

    fechaNovaAnotacao() {
      this.formAnotacao.visivel = false;
    },

    adicionarAnotacaoHandle() {
      let formData = new FormData();
      formData.set('tipo', this.formAnotacao.tipo);
      formData.set('descricao', this.formAnotacao.mensagem);
      formData.set('total_anexos', this.formAnotacao.anexos.length);
      for (let index = 0; index < this.formAnotacao.anexos.length; index++) {
        const anexo = this.formAnotacao.anexos[index];
        formData.append(`anexo_${index + 1}`, anexo.file);
      }

      loading(true);
      return api.post(`/helpdesk/tickets/${this.ticketID}/atividades`, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(() => {
        loading(false);
        this.carregaTicket();
        this.resetFormAnotacao();
        this.fechaNovaAnotacao();
        this.carregaAtividades();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    atividadeValida(atividade) {
      //const atividades = ['atMensagemPrivada', 'atMensagemPublica'];
      //return atividades.includes(atividade.tipo);

      const atividades = ['atCriacao', 'atSolicitante', 'atContato', 'atCliente', 'atTitulo', 'atDescricao', 'atGrupo', 'atOperador', 'atEstagio', 'atMensagemPrivada', 'atMensagemPublica', 'atAtendimentoIniciado'];
      return atividades.includes(atividade.acao);
    },

    atividadePossuiAnexo(id) {
      return this.anexosAtividade(id).length > 0;
    },

    // TODO: REFATORAR
    baixaAnexo(anexo) {
      const arquivo = this.apenasNomeArquivo(anexo.caminho);
      console.log(arquivo);

      api.get(`/helpdesk/tickets/${this.ticketID}/anexos/${anexo.id}/${arquivo}`, {responseType: 'arraybuffer'}).then(res => {
        loading(false);

        let blob = new Blob([res.data], { type: 'application/octet-stream' }); // octet-stream
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.apenasNomeArquivo(anexo.caminho);
        link.click();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    // TODO: REFATORAR
    removeAnexoHandle(anexo) {
      dialogo.confirmacao(`Confirma remover o anexo: "${this.apenasNomeArquivo(anexo.caminho)}"?`).then(() => {
        api.delete(`/helpdesk/tickets/${this.ticketID}/anexos/${anexo.id}`).then(() => {
          loading(false);
          const index = this.ticket.anexos_ticket.indexOf(anexo);
            if (index > -1) {
              this.ticket.anexos_ticket.splice(index, 1);
            }
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    // TODO: REFATORAR
    anexosAtividade(id) {
      if (!this.ticket || !this.ticket.anexos_ticket) {
        return [];
      }

      const anexos = [];

      for (let index = 0; index < this.ticket.anexos_ticket.length; index++) {
        const anexo = this.ticket.anexos_ticket[index];
        if (anexo.mensagem_id === id) {
          anexos.push(anexo);
        }
      }

      return anexos;
    },

    // TODO: REFATORAR
    apenasNomeArquivo(caminho) {
      if (!caminho) {
        return '';
      }
      const pedacos = caminho.split('/');
      return pedacos[pedacos.length-1];
    },

    ticketAberto() {
      return (this.ticket && this.ticket.estagio === 'etCriacao' || this.ticket.estagio === 'etAberto');
    },

    classeAtividade(atividade) {
      if (atividade.acao === 'atEstagio' && atividade.descricao === 'etEncerrado') {
        return ['alert-danger'];
      }

      if (atividade.acao === 'atAtendimentoIniciado') {
        return ['alert-secondary'];
      }

      return ['alert-primary'];
    },

    escreveAtividade(atividade) {
      switch (atividade.acao) {
        case 'atCriacao':
          return 'Ticket criado.';

        case 'atSolicitante':
          return `Alteração do solicitante.\n • Anterior: ${atividade.descricao}`;

        case 'atContato':
          return `Alteração do contato.\n • Anterior: ${atividade.descricao}`;

        case 'atCliente':
          return `Alteração do cliente.\n • Anterior: ${atividade.descricao}`;

        case 'atTitulo':
          return `Alteração da descrição curta.\n • Anterior: ${atividade.descricao}`;

        case 'atDescricao':
          return `Alteração da descrição longa.\n • Anterior: ${atividade.descricao}`;

        case 'atGrupo':
          return `Alteração do grupo.\n • Anterior: ${atividade.descricao}`;

        case 'atOperador':
          return `Alteração do operador.\n • Anterior: ${atividade.descricao}`;

        case 'atEstagio':
          switch (atividade.descricao) {
            case 'etEncerrado':
              return `Ticket encerrado`;
          }

          return `Alteração do status.\n • Inválido`;

        case 'atMensagemPrivada':
          return `Enviou uma mensagem privada`;

        case 'atMensagemPublica':
          return `Enviou uma mensagem pública`;

        case 'atAtendimentoIniciado':
          return `Iniciou o atendimento`;
      }

      return 'Atividade inválida';
    },

    traduzTipoMensagem(tipo) {
      switch (tipo) {
        case 'atMensagemPrivada':
          return 'Interna (apenas funcionários)';

        case 'atMensagemPublica':
          return 'Público (pode ser visto pelo cliente)';

        default:
          return 'desconhecido';
      }
    },

    classeFormAnotacao() {
      switch (this.formAnotacao.tipo) {
        case 'atMensagemPrivada':
          return ['form-anotacao-privado'];

        case 'atMensagemPublica':
          return ['form-anotacao-publico'];
      }

      return [];
    }
  },
  created() {
    const ticketID = +this.$route.params.ticketID;

    if (!ticketID) {
      this.$router.push({ path: `/helpdesk` });
      return;
    }

    this.ticketID = ticketID;

    this.resetFormAnotacao();
    this.carregaMeuID();
    this.carregaTicket();
    this.carregaGrupos();
    this.carregaOperadores();
    this.carregaAtividades();
  },
  computed: {
    textoDDTipoAnotacao() {
      return this.traduzTipoMensagem(this.formAnotacao.tipo);
    },
    textoClienteSelecionado() {
      if (!this.clienteSelecionado) {
        return '';
      }

      return this.clienteSelecionado.razao_social;
    }
  },
}
</script>


<style>
.form-anotacao-privado #triggerDDTipoMensagem,
.form-anotacao-privado > textarea {
  border-color: #ffc107;
  background-color: #ffc1072d;
  color: #463400;
}

.form-anotacao-publico #triggerDDTipoMensagem,
.form-anotacao-publico > textarea {
  border-color: #198754;
  background-color: #19875411;
  color: #198754;
}

</style>
